import { FC } from 'react';
import site from 'pro/config/site';

export const FooterCopy: FC = () => {
    return (
        <div>
            &copy;{new Date().getFullYear()} {site.brand} LED
        </div>
    )
};
